export default __webpack_public_path__ + "static/media/quora_duplicate_question.d4377bcc.PNG";